// extracted by mini-css-extract-plugin
export default {"primaryBtnColor":"#3c00ff","primaryBtnHoverColor":"#150058","mintColor":"#f3faff","grayColor":"#a1a1a1"};